import HttpRequest from "./HttpRequest";
import CRUDService from "./base/CRUDService";

export default class UserService extends CRUDService {

  static currentUser = null;
  httpRequest = new HttpRequest();
  static ROLE_ADMIN = 'ADMIN';
  static ROLE_SUPER = 'SUPER';
  static ROLE_USER = 'USER';
  static ROLE_MAP_VACANCY = 'MAP_VACANCY'
  static ROLE_DASH_CONFIG = 'DASH_CONFIG'

  getMe() {
    return this.httpRequest.get('auth/v1/users/me').then(data => UserService.currentUser = data);
  }

  getBaseURL() {
    return 'auth/v1/users/';
  }

  saveProfiles(id, profileIds) {
    return this.getHttpRequest().put(`${this.getBaseURL()}${id}/profiles`, profileIds);
  }

  static hasRoles(roles) {
    if (!UserService.currentUser) {
      return false;
    }

    if (roles.length === 0) {
      return true;
    }

    let authorities = [];
    UserService.currentUser.profiles.forEach(p => authorities = authorities.concat(p.authorities));

    const hasRole = authorities.filter((item) => roles.indexOf(item.role) >= 0);

    return hasRole.length > 0;
  }

  static getCompanyId() {
    return UserService.currentUser && UserService.currentUser.company.id;
  }

  static isSuper() {
    return this.hasRoles([UserService.ROLE_SUPER]);
  }

  deleteUserById(userId) {
    return this.httpRequest.delete(`${this.getBaseURL()}${userId}`)
  }

  findAll(sizeRequest) {
    return this.httpRequest.get(`${this.getBaseURL()}?size=${sizeRequest}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/UserService.js